import { cs } from '@/utils/className';
import { Icon } from '@arco-design/web-react';
import { isFunction, isUndefined } from 'lodash';
import React from 'react';
import styles from './index.module.less';

export default class Text extends React.PureComponent<any> {
  render() {
    const { icon, title, description, className, ellipsis, extra, onClick, align } = this.props;

    return (
      <div
        className={cs(
          styles.wrapper,
          { [styles.clickable]: !!onClick, [styles.ellipsis]: ellipsis },
          className,
        )}
        onClick={onClick}
      >
        {icon &&
          (isFunction(icon) ? (
            icon()
          ) : (
            <Icon className={styles.icon} name={icon} style={{ fontSize: 40 }} />
          ))}
        <div className={styles.text} style={{ alignItems: align }}>
          <span>
            {isFunction(title) ? title() : isUndefined(title) || title === '' ? '-' : title}
          </span>
          <span>{description}</span>
        </div>
        {extra}
      </div>
    );
  }
}
